import React from 'react'
import { formatScore } from '../../utils/formatNumber'

const TIER_CLASS: Record<string, string> = {
  NEW_MEMBER: 'border-white/20 bg-white/10 text-white/85',
  REGULAR: 'border-sky-300/40 bg-sky-400/10 text-sky-100',
  TRUSTED: 'border-emerald-300/40 bg-emerald-400/10 text-emerald-100',
  HIGH_TRUST: 'border-amber-300/40 bg-amber-400/10 text-amber-100',
  ELITE: 'border-fuchsia-300/40 bg-fuchsia-400/10 text-fuchsia-100',
}

const TIER_LABEL: Record<string, string> = {
  NEW_MEMBER: 'New Member',
  REGULAR: 'Regular',
  TRUSTED: 'Trusted',
  HIGH_TRUST: 'High Trust',
  ELITE: 'Elite',
}

export default function ReputationBadge({
  tier,
  score,
  onViewDetails,
}: {
  tier?: string | null
  score?: number | null
  onViewDetails?: () => void
}) {
  const key = String(tier || 'NEW_MEMBER').toUpperCase()
  const label = TIER_LABEL[key] || key.replace(/_/g, ' ')
  const klass = TIER_CLASS[key] || TIER_CLASS.NEW_MEMBER

  return (
    <div className="mt-3 flex flex-wrap items-center gap-2 sm:gap-2.5" data-no-tapback="1">
      <span className={`inline-flex min-h-8 items-center rounded-full border px-3 py-1 text-xs font-semibold tracking-wide ${klass}`}>
        Trust Tier: {label}
      </span>
      {typeof score === 'number' ? (
        <span className="inline-flex min-h-8 items-center rounded-full border border-white/15 bg-black/35 px-2.5 py-1 text-xs text-white/80">
          Score {formatScore(score)}
        </span>
      ) : null}
      {onViewDetails ? (
        <button
          type="button"
          onClick={onViewDetails}
          aria-label="View reputation details"
          className="inline-flex min-h-8 items-center rounded-full border border-white/15 bg-white/5 px-3 py-1 text-xs text-white/85 hover:bg-white/10 hover:text-white"
        >
          View reputation details
        </button>
      ) : null}
    </div>
  )
}
